import { DamageCodeResource, CreateDamageCodeRequest, UpdateDamageCodeRequest  } from "../api/barcodeSystem/damageCode";

export class EditDamageCodeModel {
    isNew: boolean;
    code: string;
    description: string;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    showForNewDamageCode() {
        this.isNew = true;
        this.loading = false;
    }

    showForExistingDamageCode(damageCode: DamageCodeResource) {
        this.isNew = false;
        this.loading = false;
        this.code = damageCode.code;
        this.description = damageCode.description;
    }

    toCreateDamageCodeRequest(): CreateDamageCodeRequest {
        return { 
          code: this.code, 
          description: this.description
        };
    }

    toUpdateDamageCodeRequest(): UpdateDamageCodeRequest {
        return {
          code: this.code, 
          description: this.description
        };
    }
}
